import React from "react";
import { CircularProgress } from "@mui/material";

const CSSLoader = ({ onCancel, text }) => {
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  };

  return (
    <div style={loaderStyle}>
      <CircularProgress size={50} />
    </div>
  );
};

export default CSSLoader;
